// TODO: we create this files until we create a unification style for handle api responses, this file has been created in order to reduce duplicated logic with metrics api

import metricsApi from '../../metrics/Api';
import reportErrorToSentry from '~/utils/reportErrorToSentry';
import { isServerSide } from '../../../utils/isomorphic';

export default function oldStyleResponse(promiseResponse, ApiError, metricsData) {
  let response = null;

  const mustSaveMetrics = isServerSide() && typeof metricsData !== 'undefined';
  const startTime = new Date();

  return promiseResponse
    .then(res => {
      response = res;
      return response.json();
    })
    .then(json => {
      if (json.errors) {
        const error = Array.isArray(json.errors) ? json.errors[0] : json.errors;
        const errorMessage = `${json.reason} - ${error.error}`;

        if (mustSaveMetrics) {
          metricsApi.incrementError(metricsData).catch(errorApi => {
            throw errorApi;
          });
        }

        throw new ApiError(error.status, errorMessage, response.status);
      }

      if (mustSaveMetrics) {
        const endTime = new Date();
        metricsApi.incrementQuery(metricsData).catch(errorApi => {
          throw errorApi;
        });
        const responseTime = endTime - startTime;
        metricsApi.storeResponseTime({ ...metricsData, responseTime }).catch(errorApi => {
          throw errorApi;
        });
      }

      return json;
    })
    .catch(error => {
      if (error.type === 'request-timeout') {
        if (mustSaveMetrics) {
          metricsApi.incrementTimeout(metricsData).catch(errorApi => {
            throw errorApi;
          });
        }
      }

      // we don't want to report Search/Keywords not found API errors
      if (error.status !== 404) {
        reportErrorToSentry(error);
      }

      throw error;
    });
}



// WEBPACK FOOTER //
// ./app/sdk/common/handleApiResponses/oldStyleResponse.js